import Localbase from "localbase";

let db = new Localbase("db");
db.config.debug = false;
const initialState = {
  buttonValue: false,
  doneArray: [],
  notDoneArray: [],
  orderArray: [],
  transaction: [],
  memberTime: "",
  userData: [],
  profileItems: [],
  profileItemOrders: [],
  paymentProfiles: [],
  events: [],
  paymentProfileName: "",
  locations: [],
  linkPay: [],
  linkPayMeta: { has_pending_custom_link: false },
  cardPayments: [],
  cashPayments: [],
  memberPayments: [],
  gridViewLists: [],
  transactionsItems: [],
  userAssignment: [],
  myOrganizations: [],
  dashboardData: [],
  paginationNext : "",
  paginationPrevious: "",
  paginationCount: "",
  debugLogs: [],
  deviceReboot: [],
  paginationCurrent: "",
  transactionTotal: [],
  categoryList: [],
  inventoryDashboard: [],
  analyticsDashboardData: [],
  enableCashDiscount: false,
  showUniversalLoader: false
};

const reducer = (state, action) => {
  switch (action.type) {
    case "DONE":
      return {
        ...state,
        buttonValue: true,
      };
    case "NOT_DONE":
      return { ...state, buttonValue: false };
    case "ORDERS":
      return {
        ...state,
        orders: action.payload,
      };
    case "TOTALDATA":
      return {
        ...state,
        totalData: action.payload,
      };
    case "RETURN":
      return {
        ...state,
        returnData: action.payload,
      };
    case "SIDER":
      db.collection("sider").add({
        siderData: action.payload,
      });
      return {
        ...state,
        siderData: action.payload,
      };
    case "SIDERRETURN":
      // db.collection("siderReturn").add({
      //   siderData: action.payload,
      // });
      return {
        ...state,
        siderReturnData: action.payload,
      };
    case "ORDERARRAY":
      return {
        ...state,
        orderArray: [...state.orderArray, action.payload],
      };
    case "DONEARRAY":
      db.collection("doneArray").add({
        doneArray: [...state.doneArray, action.payload],
      });
      return {
        ...state,
        doneArray: [...state.doneArray, action.payload],
      };

    case "NOTDONEARRAY":
      return {
        ...state,
        notDoneArray: [...state.notDoneArray, action.payload],
      };

    case "INITIAL_ORDER_STATE":
      return {
        ...state,
        orderArray: action.payload,
      };

    case "INITIAL_DONE_STATE":
      return {
        orderArray: action.payload,
      };

    case "TRANSACTION":
      return {
        ...state,
        transaction: action.payload,
      };
    case "TRANSACTION_ITEMS":
      return {
        ...state,
        transactionsItems: action.payload,
      };
    case "MEMBERTIME":
      return {
        ...state,
        memberTime: action.payload,
      };
    case "USER_DATA":
      return {
        ...state,
        userData: action.payload,
      };
    case "PROFILE_ITEMS":
      return {
        ...state,
        profileItems: action.payload,
      };
    case "PROFILE_INFO":
      return {
        ...state,
        profileInfo: action.payload,
      };
    case "PROFILE_ITEMS_ORDERS":
      return {
        ...state,
        profileItemOrders: action.payload,
      }
    case "PAYMENT_PROFILES":
      return {
        ...state,
        paymentProfiles: action.payload,
      };
    case "EVENTS":
      return {
        ...state,
        events: action.payload,
      };
    case "LOCATION":
      return {
        ...state,
        locations: action.payload,
      }
    case "LINK_PAY":
      return {
        ...state,
        linkPay: action.payload,
      }
    case "LINK_PAY_META":
      return {
        ...state,
        linkPayMeta: action.payload,
      }
    case "ENABLE_CASH_DISCOUNT":
      return {
        ...state,
        enableCashDiscount: action.payload,
      };
    case "USER_ASSIGNMENT":
      return {
        ...state,
        userAssignment: action.payload,
      };
    case "PAYMENT_PROFILE_NAME":
      return {
        ...state,
        paymentProfileName: action.payload,
      };
    case "CARD_PAYMENTS":
      return {
        ...state,
        cardPayments: action.payload,
      };
    case "CASH_PAYMENTS":
      return {
        ...state,
        cashPayments: action.payload,
      };
    case "MEMBER_PAYMENTS":
      return {
        ...state,
        memberPayments: action.payload,
      };
    case "GRIDVIEW_LISTS":
      return {
        ...state,
        gridViewLists: action.payload,
      };
    case "MY_ORGANIZATIONS":
      return {
        ...state,
        myOrganizations: action.payload,
      };
    case "DASHBOARD_DATA":
      return {
        ...state,
        dashboardData: action.payload,
      }
    case "PAGINATION_DATA":
      return {
        ...state,
        paginationCount: action.payload[0],
        paginationNext : action.payload[1],
        paginationPrevious: action.payload[2],
        paginationCurrent: action.payload[3],
        transactionTotal: action?.payload[4],
      }
    case "CATEGORY_LIST":
      return {
        ...state,
        categoryList: action.payload
      }
    case "INVENTORY_DASHBOARD":
      return {
        ...state,
        inventoryDashboard: action.payload
      }
    case "DEBUG_LOGS":
      return {
        ...state,
        debugLogs: action.payload
      }
    case "DEVICE_REBOOT":
      return {
        ...state,
        deviceReboot: action.payload
      }
    case "SHOW_UNIVERSAL_LOADER":
      return {
        ...state,
        showUniversalLoader: true
      }
    case "HIDE_UNIVERSAL_LOADER":
      return {
        ...state,
        showUniversalLoader: false
      }
    default:
      return;
  }
};

export { reducer, initialState };
